import QRCode from "react-qr-code";
import React from "react";
import I18n from "i18n-js";
import PropTypes from "prop-types";

BsffList.propTypes = {
  bsffs: PropTypes.arrayOf(
    PropTypes.shape({
      designation: PropTypes.string.isRequired,
      bordereauId: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired,
    }).isRequired,
  ).isRequired,
  showTrackdechetsSynced: PropTypes.bool,
  trackdechetsSynced: PropTypes.bool,
};

export default function BsffList({
  bsffs,
  showTrackdechetsSynced = false,
  trackdechetsSynced = false
}) {
  return (
    <div key={`bsff-list-intervention`}>
      <h4>{I18n.t("trackdechets.bsff.list.title")}</h4>
      {showTrackdechetsSynced && (
        <dl className="row mb-1">
          <dt className="col-sm-6">
            {I18n.t("trackdechets.synchronised")}
          </dt>
          <dd className="col-sm-6">
            {trackdechetsSynced
              ? I18n.t("common.yes")
              : I18n.t("common.no")
            }
          </dd>
        </dl>
      )}
      <ul className="list-group">
        {bsffs.map((bsff) => {
          return (
            <li key={`bsff-${bsff.id}`} className="list-group-item">
              <div className="row switch-qrcode">
                <div className="col-sm-9">
                  <dl>
                    <dt>{I18n.t("trackdechets.bsff.list.designation")}</dt>
                    <dd>{bsff.designation ?? "-"}</dd>
                    <dt>{I18n.t("trackdechets.bsff.list.noteId")}</dt>
                    <dd>{bsff.bordereauId}</dd>
                    <dt>{I18n.t("trackdechets.bsff.list.status")}</dt>
                    <dd>{I18n.t("trackdechets.bsff.status." + bsff.status)}</dd>
                  </dl>
                </div>
                <div className="col-sm-3 align-self-center pe-sm-4">
                  <div className="d-flex justify-content-center justify-content-sm-end">
                    <QRCode
                      className="blur-qrcode"
                      value={bsff.bordereauId}
                      size={128}
                    />
                  </div>
                </div>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
